import {
  Button,
  Dialog,
  Grid,
  Modal,
  TextLink,
  Text,
  Field,
  FormRow
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { DateService } from 'common/services/date-service';
import { useTranslation } from 'react-i18next';

type MultipleLinkedObjectModalProps = {
  visible: boolean
  onClose: () => void,
  linkedItems: IObject[],
  onNavigate: (item: IObject) => void;
  linkedObject: IObject;
};

export const MultipleLinkedObjectModal = ({
  visible,
  onClose,
  linkedItems,
  onNavigate,
  linkedObject
}: MultipleLinkedObjectModalProps) => {
  const { t } = useTranslation();
  const getDateLastRow = (surveyDate: string) => {
    if (surveyDate) {
      return `Date: ${DateService.format(surveyDate)}`
    }
  }
  const content = <Grid gap={10}>
    <Text>{t(translations.objects_linkedItemModalTitle, { name: linkedObject.name, type: linkedObject.type })}</Text>
    {linkedItems.map(item => {
      return <FormRow>
        <Field>
          <TextLink onClick={() => onNavigate(item)} key={item.objectid}>
            <Text>{item?.associateddata?.surveyRunName}</Text>
          </TextLink>
        </Field>
        <Field>
          Rows: {item.data?.length - 1}, {getDateLastRow(item.data.at(-1).surveyDate)}
        </Field>
      </FormRow>
    })}
  </Grid>

  return (
    <Modal visible={visible} centered>
      <Dialog
        dialog={{
          scroll: false,
          heading: t(translations.selectItem),
          content,
          width: 300,
          onClose,
          footer: (
            <>
              <Button onClick={onClose} label={t(translations.cancel)} />
            </>
          ),
        }}
      />
    </Modal>
  );
};